import React, { Component } from "react";
import Tooltip from 'rc-tooltip';
import Pagination from "react-js-pagination";
import { isIE, isMobile } from "react-device-detect";
import { Input, Button } from "reactstrap";

//Daterangepicker
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import { CopyToClipboard } from "react-copy-to-clipboard";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

import _ from "lodash";
import moment from 'moment';
import { Modal } from "react-bootstrap";

import CancelSessionConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import { getMessage } from "CONFIG/i18n";

//Utility
import { SESSION_STATUS, TIME_INTERVAL, MODAL_TYPE, PAGE_COUNT } from "UTILS/Constants";
import { getPhoneNumberWithoutCountryCode } from "UTILS/Utility";

//ASSETS
import icCopy from "ASSETS/Images/ic_copy_session_link.svg";
import icCheck from "ASSETS/Images/ic_check.svg";
import icBar from "ASSETS/Images/ic_bar.svg";
import icSuccessModal from "ASSETS/Images/ic_session_scheduled_popup.svg";
import icFailedModal from "ASSETS/Images/ic_session_scheduled_popup_Failed.svg";
import icEclipse from "ASSETS/Images/ic_eclipse.svg";
import icOption from "ASSETS/Images/ic_option.svg";
import icEdit from "ASSETS/Images/ic_edit.svg";
import icCancelMeeting from "ASSETS/Images/ic_cancel_meeting.svg";
import icArrow from "ASSETS/Images/ic_arrow.svg";
import icCalendarSmall from "ASSETS/Images/ic_calendar_small.svg";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

//stylesheet
import "./ScheduleSessionTable.less";
import 'react-dates/lib/css/_datepicker.css';
import 'rc-tooltip/assets/bootstrap_white.css';

export class ScheduleSessionTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedSessionKey: "",
      hideActiveSessionKeys: [],
      deleteSessionKey: "",
      counter: 0,
      refreshTableDataInterval: 0,
      showModal: false,
      modalMessage: "",
      startDate: moment(),
      endDate: moment().add(1, "days"),
      focusedInput: null,
      displayPage: 1,
      sessionListPageSize: 10,
      buttonDisabled: false,
    }
    this.tableRef = React.createRef();
  }

  componentDidMount() {
    // TODO: optimize
    let refreshTableDataInterval = setInterval(() => {
      this.setState({ counter: this.state.refreshTableDataInterval })
    }, TIME_INTERVAL.SESSION_TABLE_REFRESH_TIME_INTERVAL);

    this.setState({
      refreshTableDataInterval: refreshTableDataInterval
    })
  }

  componentWillUnmount() {
    clearInterval(this.state.refreshTableDataInterval);
  }

  //show confirmation dialogue for delete request 
  handleCancelMeeting = (sessionKey) => {
    this.setState({
      deleteSessionKey: sessionKey,
      showCancelSessionConfirmationModal: true
    });
  }

  // on arrow click of show session list
  showActiveSessionInvitees = (showSessionKey) => {
    this.setState({
      hideActiveSessionKeys:
        this.state.hideActiveSessionKeys.filter((sessionKey) => sessionKey !== showSessionKey)
    })
  }

  // on arrow click for hide session list
  hideActiveSessionInvitees = (sessionKey) => {
    this.setState({
      hideActiveSessionKeys: [...this.state.hideActiveSessionKeys, sessionKey]
    })
  }

  //cancel session request function
  cancelSession = () => {
    this.props.cancelMeeting(this.state.deleteSessionKey,
      this.handleCancelMeetingSuccess,
      this.handleMeetingError);
    this.closePopUp();
  }

  // handle successful cancel meeting
  handleCancelMeetingSuccess = () => {
    this.setState({
      modalMessage: getMessage("CANCEL_MEETING_SUCCESS_MESSAGE"),
      modalType: MODAL_TYPE.SUCCESS,
      modalIcon: icSuccessModal
    }, () => {
      this.setState({ showModal: true })
      this.fetchTableData();
    })
  }

  // handle failure to cancel and start meeting
  handleMeetingError = (errorMessage) => {
    this.setState({
      modalMessage: getMessage(errorMessage),
      modalType: MODAL_TYPE.FAILURE,
      modalIcon: icFailedModal
    }, () => {
      this.setState({ showModal: true })
      this.fetchTableData();
    })
  }

  toggleModal = () => {
    this.setState({
      showModal: false,
      modalMessage: "",
      modalType: "",
      modalIcon: ""
    })
  }

  closePopUp = () => {
    this.setState({
      deleteSessionKey: "",
      showCancelSessionConfirmationModal: false
    });
  }

  shouldShowStartButton = (sessionData) => {
    return (
      // if session is not yet started or is in closing state and is scheduled in next 5 mins
      (moment().valueOf() + (parseInt(window._env_.REACT_APP_START_SCHEDULE_SESSION_PRIOR_TIME_IN_MIN) * 60000)
        >= moment(sessionData.scheduledStartTime).valueOf() || this.isSessionSelected(sessionData.sessionKey)) &&
      (sessionData.status === SESSION_STATUS.CREATED || sessionData.status === SESSION_STATUS.WAITING ||
        sessionData.status === SESSION_STATUS.CLOSING)
    );
  }

  shouldShowKebabMenu = (sessionData) => {
    return (
      // if session is not consumed 
      (sessionData.status === SESSION_STATUS.CREATED || sessionData.status === SESSION_STATUS.WAITING)
    );
  }

  isSessionSelected = (sessionKey) => {
    return this.state.selectedSessionKey === sessionKey;
  }

  //select particular session
  selectSession = (sessionKey) => {
    this.setState({
      selectedSessionKey: this.state.selectedSessionKey !== sessionKey ? sessionKey : ""
    })
  }

  fetchTableData = () => {
    this.props.getSessionList(
      this.state.startDate,
      this.state.endDate,
      this.state.displayPage - 1,
      this.state.sessionListPageSize)
    this.tableRef.current.scrollTop = 0;
  }

  changePage = (displayPage) => {
    this.state.displayPage !== displayPage &&
      this.setState({ displayPage }, () => this.fetchTableData())
  }

  changePageCount = (event) => {
    this.setState({ sessionListPageSize: Number(event.target.value), displayPage: 1 },
      () => this.fetchTableData())
  }

  changeDate = (date) => {
    this.setState({
      startDate: date.startDate,
      endDate: date.endDate,
    });
  };
  
  searchDate = async () => {
    try {
      this.setState({ buttonDisabled: true });
      if(this.state.startDate && this.state.endDate) {
        await this.fetchTableData();
      }
    } catch (error) {
      console.error("Error fetching table data:", error);
    } finally {
      this.setState({ buttonDisabled:false });
    };
  }

  getSessionOptions = (session) => {
    let sessionLink = window.location.origin + (this.props.customerUriIdentifier
      ? '/' + this.props.customerUriIdentifier : '') + "/join?sessionKey=" + session.sessionKey + "&openExternalBrowser=1";
    return (
      <div className="sessionOptions">
        <div
          className="d-flex flex-row pb-2 sessionOptions"
          onClick={() => this.props.editSessionRequest(session)}>
          <img src={icEdit} className="cursorPointer pr-3" />
          <span className="cursorPointer">{getMessage("EDIT")}</span>
        </div>
        {isIE ? (
          <div className="d-flex flex-row pb-2 sessionOptions"
            onClick={() => {
              window.clipboardData && window.clipboardData.setData("Text",sessionLink);
              if (window.clipboardData && window.clipboardData.getData("Text")) {
                toastr.info(getMessage("SESSION_LINK_COPIED"));
              } else {
                toastr.info(getMessage("SESSION_LINK_NOT_COPIED"));
              }
            }}>
            <img src={icCopy} className="cursorPointer pr-3" />
            <span
              className="cursorPointer"
            >
              {getMessage("COPY_LINK")}
            </span>
          </div>
        ) : (
          <div className="d-flex flex-row pb-2 sessionOptions">
            <CopyToClipboard
              text={sessionLink}
              onCopy={(text, result) => {
                if (result)
                  toastr.info(getMessage("SESSION_LINK_COPIED"));
                else
                  toastr.info(getMessage("SESSION_LINK_NOT_COPIED"));
              }}
            >
              <img src={icCopy} className="cursorPointer pr-3" />
            </CopyToClipboard>
            <CopyToClipboard
              text={sessionLink}
              onCopy={(text, result) => {
                if (result)
                  toastr.info(getMessage("SESSION_LINK_COPIED"));
                else
                  toastr.info(getMessage("SESSION_LINK_NOT_COPIED"));
              }}
            >
              <span
                className="cursorPointer"
              >
                {getMessage(
                  "COPY_LINK"
                )}
              </span>
            </CopyToClipboard>
          </div>
        )}
        <div
          className="d-flex flex-row"
          onClick={() => this.handleCancelMeeting(session.sessionKey)}>
          <img src={icCancelMeeting} className="cursorPointer pr-3" />
          <span className="cursorPointer">{getMessage("CANCEL_MEETING")}</span>
        </div>
      </div>
    )
  }

  render() {
    const { scheduleDataList } = this.props;
    let calendarNode = (<img src={icCalendarSmall} />)
    let arrowNode = (<div className="px-2">~</div>)
    return (
      <div className="d-flex justify-content-center scheduleSessionTableWrapper">

        {/*confirmation modal on cancel session*/}
        <Modal show={this.state.showModal} className="scheduleSessionTableModal" centered>
          <div className="p-3">
            <div className="d-flex justify-content-center">
              <img src={this.state.modalIcon} />
            </div>
            < div className={
              this.state.modalType === MODAL_TYPE.SUCCESS ?
                "d-flex justify-content-center p-3 modalMessage" :
                "d-flex justify-content-center p-3 failureModalMessage"
            }
            >{this.state.modalMessage}</div>
            <div className="d-flex justify-content-center p-3">
              <div className="col-md-5">
                <button
                  type="button"
                  className={
                    this.state.modalType === MODAL_TYPE.SUCCESS ?
                      "btn w-100 rounded-pill modalBtn whiteOnClick border-0" :
                      "btn w-100 rounded-pill modalBtnFailure whiteOnClick border-0"}
                  onClick={this.toggleModal}
                >
                  {getMessage("OK")}
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {this.state.showCancelSessionConfirmationModal ? (
          <CancelSessionConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={this.closePopUp}
            handleYesClick={this.cancelSession}
            message={getMessage("CANCEL_SESSION_CONFIRMATION_TEXT")}
          />
        )
          : null
        }
        <div className="col-md-12 meetingsTable">
          <div className="d-md-flex d-block flex-row align-items-center justify-content-between tableTitle">
            <div>
              <img src={icBar} className="mr-1" />
              {getMessage("MEETING_SCHEDULE")}
            </div>
            <div className="col pl-0 pt-1 px-md-auto d-flex datePickerMainDiv">
              <DateRangePicker
                startDateId="startDate"
                endDateId="endDate"
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                onDatesChange={this.changeDate}
                focusedInput={this.state.focusedInput}
                onFocusChange={(focusedInput) => { this.setState({ focusedInput }) }}
                noBorder={true}
                startDatePlaceholderText={getMessage("FROM")}
                endDatePlaceholderText={getMessage("TO")}
                showDefaultInputIcon={true}
                inputIconPosition={"after"}
                displayFormat="YYYY/MM/DD"
                monthFormat={getMessage("DATE_PICKER_FORMAT")}
                customInputIcon={calendarNode}
                customArrowIcon={arrowNode}
                isOutsideRange={() => false}
                numberOfMonths={isMobile ? 1 : 2}
                hideKeyboardShortcutsPanel
              />
            </div>
            <Button 
              className={"mr-4 customBtn searchButton"}
              onClick={this.searchDate}
              disabled={this.state.buttonDisabled}
            >
              {getMessage("SEARCH")}
            </Button>
          </div>
          <div ref={this.tableRef}
            className={isIE ?
              "scheduleSessionTable pb-2"
              : "scheduleSessionTable"}
            id="scheduleSessionTable">
            <div className="pr-1" id="table">
              {scheduleDataList && scheduleDataList.length > 0 ?
                scheduleDataList.map(session =>
                  <div key={session.sessionKey}
                    onClick={()=>this.selectSession(session.sessionKey)}
                    id={session.sessionKey}
                    className={this.isSessionSelected(session.sessionKey) ?
                      "meetingsTableData align-items-center p-2 my-2 justify-content-between sessionDataSelected" :
                      "meetingsTableData align-items-center p-2 my-2 justify-content-between sessionData"
                    }>
                    <div className="col-lg-1 col-md-1 d-flex flex-row checkImage"
                      onClick={() => this.selectSession(session.sessionKey)}>
                      <div className="d-flex align-items-center">
                        <img
                          src={this.isSessionSelected(session.sessionKey) ? icCheck : icEclipse}
                          className="mr-3 selectIcon" />
                      </div>
                    </div>
                    <div
                      className="col-lg-1 col-md-1 pl-2 pr-3 d-flex flex-row sessionDateTime"
                      onClick={() => this.selectSession(session.sessionKey)}>
                      <div className="d-flex flex-column">
                        <span className="date">{moment(session.scheduledStartTime).format("YYYY/MM/DD")}</span>
                        <span className="time">{moment(session.scheduledStartTime).format("HH:mm") + " - "}
                          {moment(session.scheduledEndTime).format("HH:mm")}</span>
                      </div>

                    </div>

                    <div
                      className="px-4 col-lg-3 col-md-3 text-truncate border-right border-left sessionName"
                      data-toggle="tooltip"
                      title={session.sessionName}
                      onClick={() => this.selectSession(session.sessionKey)}>
                      {session.sessionName}
                    </div>

                    <div className="col-lg-4 col-md-4 usersMobileOrEmail"
                      onClick={() => this.selectSession(session.sessionKey)}>
                      {this.isSessionSelected(session.sessionKey) ?
                        session.invitees && session.invitees.map((invitee, index) => (
                          <div
                            className="text-truncate invitee"
                            data-toggle="tooltip"
                            key={index}
                            title={invitee}>
                            {getPhoneNumberWithoutCountryCode(invitee)}
                          </div>
                        )) :
                        session.invitees && session.invitees.length > 0 &&
                        <div
                          className="text-truncate invitee"
                          data-toggle="tooltip"
                          title={session.invitees[0]}>
                          {getPhoneNumberWithoutCountryCode(session.invitees[0])}
                        </div>}
                    </div>

                    <div className="col-lg-2 col-md-2 px-0 col-sm-6 col-xs-6 col-6 participateButton">
                      {
                        this.shouldShowStartButton(session) &&
                        <button
                          type="button"
                          className="btn w-100 startBtn whiteOnClick px-2"
                          onClick={() => this.props.joinSession(session.sessionKey, this.props.uriIdentifier, this.handleMeetingError)}>
                          {getMessage("PARTICIPATE")}
                        </button>
                      }

                    </div>
                    <div className="d-flex flex-row justify-content-end moreOptionsImage">
                      {this.shouldShowKebabMenu(session) &&
                        <div className="d-flex align-items-center">
                          <Tooltip
                            placement="bottom"
                            id={session.sessionKey}
                            trigger={['click']}
                            overlay={() => this.getSessionOptions(session)} >
                            <img
                              src={icOption}
                              className="pl-3 cursorPointer imgDots responsive"
                              data-for={session.sessionKey}
                              data-tip={session.sessionKey} />
                          </Tooltip>
                        </div>
                      }
                    </div>
                  </div>
                ) :
                <div className="card card-body cardReplacement text-center mt-2 tableTitle">
                  {getMessage("NO_SESSION_SCHEDULED")}
                </div>
              }
            </div>
          </div>
          {
            scheduleDataList.length > 0 &&
            <div className="justify-content-between px-2 pt-2 paginationMainDiv">
              <div>
                {getMessage("PAGINATION_TOTAL_ENTRIES",
                  {
                    from: (this.state.displayPage - 1) * this.state.sessionListPageSize + 1,
                    to: (this.state.displayPage - 1) * this.state.sessionListPageSize + scheduleDataList.length,
                    totalCount: this.props.sessionCount
                  })}
              </div>
              <div className="pageNumbers">
                {this.props.sessionCount > this.state.sessionListPageSize &&
                  <Pagination
                    activePage={this.state.displayPage}
                    itemsCountPerPage={this.state.sessionListPageSize}
                    totalItemsCount={this.props.sessionCount}
                    pageRangeDisplayed={3}
                    onChange={this.changePage}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                }
              </div>
              <div className="sessionCount">
                <Input type="select" className="inputFormControl form-control border" onChange={this.changePageCount}>
                  {
                    PAGE_COUNT.map((count) => (
                      <option key={count} value={count}>{count}</option>
                    )
                    )
                  }
                </Input>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default modalScrollBar(ScheduleSessionTable);
